import React, { Component } from 'react'
import _ from 'lodash'

import { updateModuleData } from 'helpers/specHelpers'
import CommonSpec from 'containers/Project/CommonSpec/index'

class GeneralSpec extends Component {
/**
 *
 * Takes in the initValues and modifiedValues field of project_ssid or project_svid
 * and combine values into form 'value1, value2,....'
 *
 * @param {Array} dataArr
 * @returns
 * @memberof GeneralSpec
 */
  combineData(dataArr) {
    if (!dataArr) return

    return [{
      value: dataArr.reduce((accumulateObj, curVal, index) =>
        // add comma after first value
        index > 0 ? `${accumulateObj}, ${curVal.value}` : curVal.value.toString(), '')
    }]
  }

  render() {
    const {
      moduleData,
      isModifiedPage,
      curFilter,
      ModuleHeader,
    } = this.props
    const newModuleData = _.cloneDeep(moduleData)
    newModuleData.project_ssid = updateModuleData(newModuleData.project_ssid, this.combineData)
    newModuleData.project_svid = updateModuleData(newModuleData.project_svid, this.combineData)

    return (
      <CommonSpec
        moduleName='project'
        moduleData={newModuleData}
        isModifiedPage={isModifiedPage}
        curFilter={curFilter}
        ModuleHeader={ModuleHeader}
      />
    )
  }
}

export default GeneralSpec
